import { render, staticRenderFns } from "./salesTemplate.vue?vue&type=template&id=0d9c0915&scoped=true"
import script from "./salesTemplate.vue?vue&type=script&lang=js"
export * from "./salesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c0915",
  null
  
)

export default component.exports